import Context from "./Context";
import Line from "./Line";
import {Block, GameObject, Sprite, Property, Action, GlobalAction, Constant, Util, Variable, Operator, Callback} from "./Block";
import {STATE, GRAMMAR, CATEGORY, BLOCK} from "./Type";

export default {
  Context,
  Line,
  Block,
  GameObject,
  Sprite,
  Property,
  Action,
  GlobalAction,
  Constant,
  Util,
  Variable,
  Operator,
  Callback,
  TYPE: {STATE, GRAMMAR, CATEGORY, BLOCK},
};
